import { ErrorMessage, Field, Form, Formik } from "formik";
import { Modal } from "react-bootstrap";
import { IQualification } from "..";
import axiosClient from "../../../../../utils/api/axiosClient";
import { getToken } from "../../../../../utils/functions";
import { QualificationSchema } from "../validation";

export default function FormModel(props: any) {
  const { setQualifications, initial, setInitial, modalShow, setModalShow } =
    props;

  const handleSubmit = (values: IQualification) => {
    const headers = { Authorization: getToken() };
    // create
    const formData = {
      name: values.name,
      code: values.code,
      status: values.status,
    };
    if (initial.id) {
      axiosClient
        .put("v1/qualifications/" + initial.id, formData, { headers })
        .then((res) => {
          if (res.status === 200) setQualifications(res.data);
        });
    } else {
      axiosClient
        .post("v1/qualifications", formData, { headers })
        .then((res) => {
          if (res.status === 200) setQualifications(res.data);
        });
    }
    values.name = "";
    values.code = "";
    values.status = false;
    setInitial({ id: 0, name: "", code: "", status: false });
  };

  return (
    <Modal
      show={modalShow}
      onHide={() => setModalShow(false)}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Qualification
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={initial}
          validationSchema={QualificationSchema}
          onSubmit={handleSubmit}
        >
          {({ touched, errors, values, handleChange }) => (
            <Form className="auth-form login-form">
              <div className="mb-3">
                <label htmlFor="name">Qualification Name</label>
                <Field
                  id="name"
                  name="name"
                  values={initial.name}
                  placeholder="Enter Name"
                  autoComplete="off"
                  className={`mt-2 form-control ${
                    touched.name && errors.name ? "is-invalid" : ""
                  }`}
                />

                <ErrorMessage
                  component="div"
                  name="name"
                  className="invalid-feedback"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="code">Qualification Code</label>
                <Field
                  id="code"
                  name="code"
                  values={initial.code}
                  placeholder="Enter Code"
                  autoComplete="off"
                  className={`mt-2 form-control ${
                    touched.code && errors.code ? "is-invalid" : ""
                  }`}
                />

                <ErrorMessage
                  component="div"
                  name="code"
                  className="invalid-feedback"
                />
              </div>
              <div className="extra mt-3 row justify-content-between">
                <div className="col-6">
                  <div className="form-check">
                    <label className="form-check-label" htmlFor="status">
                      Is active ?
                    </label>
                    <input
                      id="status"
                      name="status"
                      className="form-check-input"
                      type="checkbox"
                      onChange={handleChange}
                      defaultChecked={values.status}
                    />
                  </div>
                </div>
              </div>
              <div className="text-center">
                <button
                  type="submit"
                  className="btn app-btn-primary w-100 theme-btn mx-auto"
                >
                  SAVE
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}
